import React, { useState, useEffect } from 'react';
import { Header, Footer, PostCard, Archive } from '../../components';
import storage from '../../utils/storage';
import { getRelativeTime } from '../../utils/date';
import './Home.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (searchTerm) {
      const filtered = posts.filter(post => 
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (post.tags && post.tags.some(tag => 
          tag.toLowerCase().includes(searchTerm.toLowerCase())
        ))
      );
      setFilteredPosts(filtered);
    } else {
      setFilteredPosts(posts);
    }
  }, [searchTerm, posts]);

  const loadData = () => {
    try {
      const postsData = storage.getPosts();
      const usersData = storage.getUsers();
      
      // 按创建时间排序，最新的在前
      const sortedPosts = postsData.sort((a, b) => 
        new Date(b.createdAt) - new Date(a.createdAt)
      );
      
      setPosts(sortedPosts);
      setUsers(usersData);
      setLoading(false);
    } catch (error) {
      console.error('Error loading data:', error);
      setLoading(false);
    }
  };

  const getAuthor = (authorId) => {
    return users.find(user => user.id === authorId);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // 搜索逻辑在useEffect中处理
  };

  if (loading) {
    return (
      <div className="app">
        <Header />
        <main className="main">
          <div className="container">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>加载中...</p>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="app">
      <Header />
      <main className="main">
        <div className="container">
          {/* 搜索栏 */}
          <div className="home-search">
            <form onSubmit={handleSearch} className="search-form">
              <input
                type="text"
                placeholder="搜索文章标题、内容或标签..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-input"
              />
              <button type="submit" className="search-button">
                🔍
              </button>
            </form>
          </div>

          {/* 统计信息 */}
          <div className="home-stats">
            <div className="stat-item">
              <span className="stat-number">{posts.length}</span>
              <span className="stat-label">文章总数</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">
                {posts.reduce((sum, post) => sum + (post.views || 0), 0)}
              </span>
              <span className="stat-label">总阅读量</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">
                {new Set(posts.map(post => post.author)).size}
              </span>
              <span className="stat-label">活跃作者</span>
            </div>
          </div>

          <div className="home-content">
            {/* 文章列表 */}
            <div className="posts-section">
              {filteredPosts.length === 0 ? (
                <div className="empty-state">
                  <h3>暂无文章</h3>
                  <p>{searchTerm ? '没有找到匹配的文章' : '还没有发布任何文章'}</p>
                </div>
              ) : (
                <div className="posts-grid">
                  {filteredPosts.map((post) => (
                    <PostCard
                      key={post.id}
                      post={post}
                      author={getAuthor(post.author)}
                    />
                  ))}
                </div>
              )}
            </div>

            {/* 侧边栏 */}
            <aside className="sidebar">
              <Archive posts={posts} />
            </aside>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Home;